<div class="app-page" style="margin-left: 10px;">

  <mat-toolbar>
    <button mat-icon-button (click)="goback()">
      <mat-icon>
        arrow_back_ios_new
      </mat-icon>
    </button>
    <span style="font-size: large; font-weight: bold;">
      {{'RANKINGLISTS.EDIT_LIST' | translate | uppercase}}
    </span>
    <!--  <button mat-button [disabled]="!this._form.valid" type="submit" style="margin-left: auto;" (click)="submit()">{{'GENERAL.SAVE' | translate | uppercase}}</button> -->
  </mat-toolbar>
  @if (loadedList && loadedCats && loadedUsers) {
    <form #selectForm [formGroup]="_form" (ngSubmit)="submit()">
      <br/>
      <div >
        <mat-form-field  appearance="fill" style="min-width: 350px;">
          <mat-label>{{'RANKINGLISTS.NAME' | translate}}</mat-label>
          <input matInput  formControlName="Description" autocomplete="false">
        </mat-form-field>
        <br/>
        <mat-form-field class="example-full-width" appearance="fill" style="min-width: 350px;">
          <mat-label>{{'RANKINGLISTS.CATEGORY' | translate}}</mat-label>
          <input type="text" matInput formControlName="Category" [matAutocomplete]="auto" >
          <mat-autocomplete #auto="matAutocomplete"  >
            @for (option of filteredCategories | async; track option) {
              <mat-option [value]="option" style="color: white;">
                {{option}}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <label>
        {{'RANKINGLISTS.ACCESS_VIEW' | translate}}
      </label>
      <label style="margin-left: 60px;">
        {{'RANKINGLISTS.ACCESS_EDIT' | translate}}
      </label>
      <br/>
      <!-- -  <mat-selection-list #sharinglist style="height: 350px;" [multiple]="true"  >
      <mat-list-option *ngFor="let usr of this.users" [value]="usr.User_Id" >
        <h4 mat-line>{{ usr.LastName }}, {{ usr.FirstName }} </h4>
      </mat-list-option>
    </mat-selection-list> -->
    @if (this.PlayerListSecurity) {
      <div style="height: 450px; overflow-y: scroll; border: gray 1px solid;"
        formArrayName="PlayerListSecurity">
        @for (access of PlayerListSecurity.controls; track access; let i = $index) {
          <div>
            <div [formGroupName]="i" STYLE="display: flex; flex-direction: row; border-bottom: gray solid 1px;">
              <div  style="width: 100px;">
                <mat-checkbox formControlName="value"></mat-checkbox>
              </div>
              <div  style="width: 100px;">
                <mat-checkbox formControlName="CanEdit"></mat-checkbox>
              </div>
              <div style="width: 200px; font-family: Roboto;" >
                {{access.get("FullName")?.value}} ({{access.get("UserName")?.value}})
              </div>
            </div>
          </div>
        }
      </div>
    }
    <!--
    <div>{{this._form.value | json }}</div> -->
    <button mat-raised-button [disabled]="!this._form.valid" type="submit">{{'GENERAL.SAVE' | translate | uppercase}}</button>
    <button mat-button type="button" (click)="goback()" >{{'GENERAL.CANCEL' | translate | uppercase}}</button>
  </form>
} @else if (isLoading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
} @else {
  <div style="padding: 16px; color: gray;">{{'GENERAL.ERROR' | translate}}</div>
}
</div>